export default __webpack_public_path__ + "assets/images/3d841da2cdc550d1fbabe16684611ac6.png";